import { Box, Flex, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SVG from "react-inlinesvg";
import { AutoCompleteInput, Suggestion } from "@/features/ui/app-autocomplete-input";

interface AppQueryInputProps {
  value?: Suggestion;
  width?: string;
  onChange?: (value: Suggestion) => void;
  showButton?: boolean;
  placeholder?: string;
  leadingIcon?: string;
  showIconsAndBtn?: boolean;
  suggestions?: Suggestion[];
}

export default function AppQueryControllerAutoComplete({
  value = { label: "", type: "custom", value: "" },
  width = "288px",
  showButton = true,
  onChange,
  placeholder = "",
  leadingIcon,
  showIconsAndBtn,
  suggestions = [],
}: AppQueryInputProps) {
  const [text, setText] = useState<Suggestion>(value);
  const { t } = useTranslation();

  useEffect(() => {
    setText(value);
  }, [value]);

  return (
    <Flex
      fontSize={"12px"}
      flexDirection={"row"}
      gap={"0px"}
      flexShrink={0}
      width={width}
      border={"1px solid #CBD5E0"}
      borderRadius={"4px"}
      _focusWithin={{
        border: "1px solid #3182ce",
        boxShadow: "0 0 0 1px #3182ce",
      }}
    >
      <Box position={leadingIcon ? "relative" : "static"} flex={1}>
        {leadingIcon && (
          <SVG
            src={`/icons-v1_1/${leadingIcon}.svg`}
            width={"20px"}
            height={"20px"}
            style={{
              position: "absolute",
              top: "50%",
              left: "6px",
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          />
        )}
        <AutoCompleteInput
          value={text}
          width="100%"
          placeholder={placeholder}
          leadingIcon={leadingIcon}
          suggestions={suggestions!}
          showButton={false}
          submit={(value) => {
            setText(value);
            if (onChange) {
              onChange(value);
            }
          }}
        />
      </Box>
    </Flex>
  );
}
